import './TextLoading.sass';

const TextLoading = () => {
    return (
        <span className='text-loading' />
    );
};

export default TextLoading;